import { useLanguage } from '../../contexts/language';
import { useSession } from '../../contexts/session';

import styles from './style.module.css';

// The signed-in person's profile as onboarding recorded it, and their email.
// Read only for now: editing the profile and changing the email are their
// own, later piece of work.
export function ProfileDetails() {
  const { text, language } = useLanguage();
  const { me } = useSession();
  const { firstName, lastName, birthDate, gender, fiscalCode } = me.profile;

  let fiscal = text.notAdded;

  if (fiscalCode != null) {
    fiscal = fiscalCode;
  }

  let born = text.notAdded;

  // A birth date needs its year, which the app's other day formats leave
  // out.
  if (birthDate != null) {
    born = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${ birthDate }T00:00:00Z`));
  }

  let described = text.notAdded;

  if (gender != null) {
    described = text.genders[ gender ];
  }

  const details = [
    [ text.firstName, firstName ],
    [ text.lastName, lastName ],
    [ text.birthDate, born ],
    [ text.gender, described ],
    [ text.fiscalCode, fiscal ],
    [ text.email, me.email ]
  ];

  const rows = details.map(function([ label, value ]) {
    return (
      <div key={ label } className={ styles.row }>
        <dt className={ styles.label }>{ label }</dt>
        <dd className={ styles.value }>{ value }</dd>
      </div>
    );
  });

  return (
    <section className={ styles.card } aria-labelledby='profile-details'>
      <h2 id='profile-details' className={ styles.heading }>{ text.profile }</h2>

      <dl className={ styles.list }>{ rows }</dl>
    </section>
  );
}
